import { ArticleCard, Footer, Header, Navbar } from "../components";
import { articles } from "../constants";
import { styles } from "../styles";

const ArtikelPage = () => {
  return (
    <>
      <Navbar />
      <Header title="Artikel" />
      <div
        className={`${styles.paddingX} flex flex-wrap items-center justify-center gap-10 py-10`}
      >
        {articles.map((article) => {
          return <ArticleCard {...article} />;
        })}
      </div>
      <Footer />
    </>
  );
};

export default ArtikelPage;
